<script setup>
import Tag from '@/components/global/Tag.vue'

const props = defineProps(['product'])
</script>

<template>
	<div class="group relative isolate flex aspect-square items-end overflow-hidden rounded-lg bg-white text-black">
		<div v-if="product.tag" class="absolute top-2 left-0 sm:top-13 sm:left-10">
			<Tag :label="product.tag" :hex="product.tag_color" />
		</div>
		<img :src="product.parent_collection.icon" :alt="product.parent_collection.icon_alt || product.parent_collection.title" class="absolute top-2 right-2 z-1 h-24 w-auto object-contain sm:top-8 sm:right-8 md:top-16 md:right-16 md:h-40" v-if="product.parent_collection.icon" />
		<div class="flex w-full items-center justify-between p-12 md:p-24">
			<router-link
				:to="{
					name: 'product',
					params: { slug: product.slug },
				}"
				class="sm:h8 h8 font-primary-condensed box-link">
				<h3>{{ product.title }}</h3>
			</router-link>
			<p class="sm:h8 h8 font-primary">{{ product.price }}</p>
		</div>
		<img class="absolute inset-0 -z-2 size-full object-cover transition-transform duration-300 group-hover:scale-102" :src="product.image" :alt="product.image_alt || product.title" />
		<img v-if="product.images?.length > 1" class="absolute inset-0 -z-1 size-full object-cover opacity-0 transition-all duration-300 group-hover:scale-102 group-hover:opacity-100" :src="product.images[1].url" :alt="product.images[1].alt || product.title" />
	</div>
</template>
